<template>
  <div class="container">
    <div class="footer-link">
      <span class="name">友情链接：</span>
      <img
        class="one-image"
        src="@/assets/images/gyhxxhb.png"
        @click="linkClick(1)"
        alt=""
      />
      <img
        class="two-image"
        src="@/assets/images/link2.png"
        @click="linkClick(2)"
        alt=""
      />
      <img
        class="three-image"
        src="@/assets/images/link3.png"
        @click="linkClick(3)"
        alt=""
      />
      <img
        class="four-image"
        src="@/assets/images/link4.png"
        @click="linkClick(4)"
        alt=""
      />
      <img
        class="five-image"
        src="@/assets/images/link5.png"
        @click="linkClick(5)"
        alt=""
      />
    </div>
    <div class="footer">
      <div class="footer-content">
        <div class="left">
          <img class="image" src="@/assets/images/footer-logo.png" alt="" />
          <p class="address">
            <img src="@/assets/images/addressIcon.png" alt="" />
            <span>地址：北京市海淀区复兴路65号电信实业大厦</span>
          </p>
          <div class="email">
            <p>
              <img src="@/assets/images/emailIcon.png" alt="" />
              <span>邮箱：</span>
            </p>
            <p style="max-width: 80%">
              数据存储专业委员会 datastorage@cesa-dsc.cn<br />
              成员服务 members@cesa-dsc.cn
            </p>
          </div>
        </div>
        <div class="QRcode">
          <img src="../assets/images/wx.jpeg" alt="" />
          <div class="name">公众号</div>
        </div>
        <div class="footer-menu">
          <div class="footer-menu-item" v-for="item in menuList" :key="item.id">
            <div class="title">{{ item.name }}</div>
            <div
              class="term"
              v-for="ele in item.children"
              :key="ele.id"
              @click="handleSelect(ele.path)"
            >
              {{ ele.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-icp">
      <div class="footer-line"></div>
      <p>版权所有：中国电子工业标准化技术协会数据存储专业委员会</p>
      <p>
        &nbsp;
        备案号：京ICP备06019433号-28&nbsp;&nbsp;&nbsp;京ICP备06019433号-29&nbsp;&nbsp;&nbsp;京ICP备06019433号-30&nbsp;&nbsp;&nbsp;京ICP备06019433号-31&nbsp;&nbsp;&nbsp;
        <img src="@/assets/images/beian.png" style="margin-right: 6px;"><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802046514" target="_blank">京公网安备11010802046514号</a>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      menuList: [
        {
          id: 1,
          name: "专委会介绍",
          children: [
            { id: 11, name: "理念宗旨", path: "/introduction/idea" },
            { id: 12, name: "组织架构", path: "/introduction/os" },
            { id: 13, name: "工作守则", path: "/introduction/rules" },
            { id: 14, name: "委员会", path: "/introduction/committee" },
          ],
        },
        {
          id: 2,
          name: "新闻动态",
          children: [
            { id: 21, name: "专委新闻", path: "/news/list" },
            { id: 22, name: "行业动态", path: "/news/notice" },
            { id: 23, name: "政策新闻", path: "/news/policyNews" },
          ],
        },
        {
          id: 5,
          name: "专家风采",
          children: [
            { id: 51, name: "专家风采", path: "/expert/list" },
          ],
        },
        {
          id: 3,
          name: "技术专区",
          children: [
            { id: 31, name: "知识专区", path: "/kb/doc" },
            { id: 32, name: "资料库", path: "/kb/term" },
            { id: 33, name: "数存百科", path: "/kb/codePractice" },
          ],
        },
        {
          id: 4,
          name: "成员服务",
          children: [
            // { id: 41, name: "成员介绍", path: "/centigrade/display" },
            { id: 42, name: "成员权益", path: "/centigrade/introduce" },
            { id: 43, name: "申请加入", path: "/centigrade/rights" },
          ],
        },
      ],
      activeIndex: "/",
    };
  },
  methods: {
    handleSelect(key) {
      if ( key == "/kb/codePractice") {
        return
      }
      this.activeIndex = key;
      switch (key) {
        case '/introduction/idea':
          this.$store.commit('SET_NAV_TITLE', '理念宗旨')
          break;
        case '/introduction/os':
          this.$store.commit('SET_NAV_TITLE', '组织架构')
          break;
        case '/introduction/rules':
          this.$store.commit('SET_NAV_TITLE', '工作守则')
          break;
        case '/introduction/committee':
          this.$store.commit('SET_NAV_TITLE', '委员会')
          break;
        case '/news/list':
          this.$store.commit('SET_NAV_TITLE', '专委新闻')
          break;
        case '/news/notice':
          this.$store.commit('SET_NAV_TITLE', '行业动态')
          break;
        case '/news/policyNews':
          this.$store.commit('SET_NAV_TITLE', '政策新闻')
          break;
        case '/kb/doc':
          this.$store.commit('SET_NAV_TITLE', '知识专区')
          break;
        case '/centigrade/dynamic':
          this.$store.commit('SET_NAV_TITLE', '成员动态')
          break;
        case '/centigrade/introduce':
          this.$store.commit('SET_NAV_TITLE', '成员权益')
          break;
        case '/centigrade/rights':
          this.$store.commit('SET_NAV_TITLE', '申请加入')
          break;
        case '/expert/list':
          this.$store.commit('SET_NAV_TITLE', '专家风采')
          break;
        default:
          break;
      }
      let routeData = this.$router.resolve({ path: key });
      window.open(routeData.href, "_blank");
    },
    linkClick(index) {
      if (index == 1) {
        window.open("https://wap.miit.gov.cn/");
      } else if (index == 2) {
        window.open("https://www.ndrc.gov.cn/");
      } else if (index == 3) {
        window.open("https://www.cac.gov.cn/");
      } else if (index == 4) {
        window.open("https://www.cesa.cn/");
      } else if (index == 5) {
        window.open("https://www.gccorg.com/");
      }
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  min-width: 1280px;
}
.footer-link {
  height: 140px;
  background-color: #eef3ff;
  display: flex;
  align-items: center;
  justify-content: center;

  .name {
    color: #000;
    font-size: 18px;
    font-weight: 700;
    line-height: 30px;
  }

  img {
    margin-right: 64.76px;
    cursor: pointer;
  }

  .one-image {
    width: 220px;
    height: 24.22px;
  }

  .two-image {
    width: 200px;
    height: 24.22px;
  }

  .three-image {
    width: 185.47px;
    height: 28.13px;
  }

  .four-image {
    width: 191.03px;
    height: 24.22px;
  }

  .five-image {
    width: 128px;
    height: 24.22px;
    margin-right: 0;
  }
}

.footer {
  width: 100%;
  height: 219px;
  background: #333333;

  .footer-content {
    width: 1280px;
    margin: 0 auto;
    padding: 25px 0;
    font-size: 16px;
    color: #fff;
    display: flex;
    position: relative;
    .left {
      width: 445px;
      .image {
        width: 229.47px;
        height: 44px;
        margin-bottom: 30px;
      }
      p {
        margin: 0;
        font-size: 16px;
        line-height: 30px;
        img {
          width: 20px;
          height: 20px;
          margin-right: 7px;
          vertical-align: -20%;
        }
      }
      .email {
        display: flex;
      }
    }
    .QRcode {
      margin: 25px 196px 0 45px;
      img {
        width: 80px;
        height: 80px;
      }
      .name {
        font-size: 14px;
        line-height: 30px;
        text-align: center;
      }
    }
    .footer-menu {
      position: absolute;
      right: 0;
      display: flex;
      .footer-menu-item {
        max-width: 85px;
        line-height: 30px;
        margin-right: 80px;
        .title {
          color: #f17b20;
          font-size: 16px;
          font-weight: 700;
        }
        .term {
          font-size: 14px;
          cursor: pointer;
        }
      }
      .footer-menu-item:last-child {
        margin-right: 0;
      }
    }
  }
}

.footer-icp {
  height: 96px;
  font-size: 14px;
  background: #333333;
  text-align: center;
  color: #f1f7fd;
  box-sizing: border-box;
  .footer-line {
    width: 1280px !important;
    height: 1px;
    margin: 0 auto 25px;
    background-color: #d9d9d9;
  }
  p {
    margin: 0 auto;
    color: #f1f7fd;
    font-size: 14px;
    line-height: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    a{
      color: #f1f7fd;
    }
  }
}
</style>
